import { ContractRequest } from 'ng2-app/services/contract-requests/contract-request.model';

export class UpdateContractRequest {
  static readonly type = '[ContractRequest] UpdateContractRequest';
  constructor(public contractRequest: any) {}
}

export class CreateContractRequest {
  static readonly type = '[ContractRequest] CreateContractRequest';
  constructor(public contractRequest: any) {}
}
